// filepath: apps/web/src/features/nav/useNavSections.ts
//
// Filters NAV_SECTIONS by the current user's isAdmin flag.
// Admin-only sections are removed entirely from the returned
// array (not display:none) so TanStack Router <Link> components
// inside them can't resolve to admin routes.

import type { NavSection } from '@osd/ui/nav';
import { NAV_SECTIONS } from './config.js';

export function useNavSections(isAdmin: boolean): ReadonlyArray<NavSection> {
  if (isAdmin) return NAV_SECTIONS;
  return NAV_SECTIONS.filter((section) => section.adminOnly !== true);
}
